/**
 * created by xcc on 2022/4/29
 * 用户管理接口
 */

import request from "../../../base/request";

let host = "/cm-sites-pms/userMediaRole/";

const Apis = {
    getAllMediaRole: "/cm-sites-pms/mediaRole/getAll", //获取当前用户部门下的所有媒体角色
    getAllUserData: "/cm-sites-sys/user/conditionQuery", //所有用户
    getUserManageListData: host + "pageList", //用户管理列表
    userManageAdd: host + 'add', //新增
    userManageUpGetById: host + 'getById', //修改
    userManageDel: host + 'delete', //删除
    userManageUpdate: host + 'update', //更新
}

export const getAllMediaRole = (body, callBack) => {
    request({url: Apis.getAllMediaRole, body, callBack});
};
export const getAllUserData = (body, callBack) => {
    request({url: Apis.getAllUserData, contentType: "json", method: "post", body, callBack});
};
export const getUserManageListData = (body, callBack) => {
    request({url: Apis.getUserManageListData, body, callBack});
};
export const userManageAdd = (body, callBack) => {
    request({url: Apis.userManageAdd, contentType: "json", method: "post", body, callBack});
};
export const userManageUpGetById = (body, callBack) => {
    request({url: Apis.userManageUpGetById, body, callBack});
};
export const userManageDel = (body, callBack) => {
    request({url: Apis.userManageDel, method: "post", body, callBack});
};
export const userManageUpdate = (body, callBack) => {
    request({url: Apis.userManageUpdate, contentType: "json", method: "post", body, callBack});
};